import { Injectable } from '@angular/core';
import { LocalService } from '@app/shared/services/local.service';
import { ProfileType } from '../enums/permissions-type.enum';
interface IProfileService {
  isMasterClient: Function;
  isMasterBO: Function;
  isClientBo: Function;
  getProfile: Function;
}

interface Profile {
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileManagerService implements IProfileService {

  constructor(private localService: LocalService,) { }

  setProfile(profile): void {
    console.log(profile)
    this.localService.setJsonValue('profile', JSON.stringify(profile));
  }

  clearProfile(): void {
    //this.localService.clearToken();
    localStorage.removeItem('profile');
    localStorage.removeItem(ProfileType.masterBo);
    localStorage.removeItem(ProfileType.master);
    localStorage.removeItem(ProfileType.clientBo);


  }

  getProfile(): string {
    return JSON.parse(this.localService.getJsonValue('profile'));
  }

  changeProfile(): void {
    if (this.isMasterBO()) {
      this.setProfile(ProfileType.masterBo);

      return;
    }
    this.setProfile(ProfileType.master);
  }

  setMasterBo() {
    this.setProfile(ProfileType.masterBo);
  }

  setMasterClient() {
    this.setProfile(ProfileType.master);
  }

  setClientBO(profile): void {
    if (profile == ProfileType.masterBo) {
      this.localService.setJsonValue(ProfileType.clientBo, JSON.stringify(true));
      return;
    }
    localStorage.removeItem(ProfileType.clientBo);
  }

  isClientBo(): boolean {
    return this.getProfile() == ProfileType.clientBo;
  }

  isMasterClient(): boolean {
    return this.getProfile() == ProfileType.master;
  }

  isMasterBO(): boolean {
    return this.getProfile() == ProfileType.masterBo;
  }
  isOperator(): boolean {
    return this.getProfile() == ProfileType.operator
  }
  isOperatorBO():boolean{
    return this.getProfile()== ProfileType.OperatorBo
  }
}
